/* eslint-disable sort-keys */
export const styledReturnButton = {
    '&:hover': {backgroundColor: 'rgba(0,0,0,0.5)'},
    'backgroundColor': 'transparent',
    'border': 0,
    'borderRadius': '$pipBorder $pipBorder 0 0',
    'bottom': '52px',
    'left': '0px',
    'outline': 'none',
    'padding': '0px',
    'position': 'absolute',
    'top': '0px',
    'variants': {pip: {false: {display: 'none'}}},
    'width': '100%',
}

export const styledVideoContainer = {
    height: '100%',
    overflow: 'hidden',
    variants: {
        pip: {true: {borderRadius: '$pipBorder'}},
        isEmbedQueueChannel: {true: {borderRadius: '0'}},
    },
    width: '100%',
}

export const styledJitsi = {
    backgroundColor: '#000',
    compoundVariants: [
        {
            channelSidebarOpen: false,
            chatOpen: true,
            css: {right: '$sizes$chatWidth'},
            pip: false,
        },
        {
            channelSidebarOpen: true,
            css: {right: '$sizes$channelSidebarWidth'},
            floating: false,
            pip: false,
        },
        {
            channelSidebarOpen: true,
            css: {right: 0},
            floating: true,
            pip: false,
        },
    ],
    position: 'absolute',
    variants: {
        channelSidebarOpen: {true: {}},
        chatOpen: {true: {}},
        floating: {
            false: {},
            true: {},
        },
        pip: {
            false: {
                bottom: 0,
                left: 0,
                right: 0,
                top: '$sizes$menubarHeight',
            },
            true: {
                borderRadius: '$pipBorder',
                height: '200px',
                right: '20px',
                top: 'calc($sizes$menubarHeight + 4px)',
                width: '300px',
                zIndex: '$jitsiPip',
            },
        },
        isEmbedQueueChannel: {
            true: {
                top: 0,
                right: 0,
                height: '100%',
                width: '100%',
            },
        },
    },
    zIndex: '$jitsi',
}
